<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal"
            style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="3">
          <data-valida etichetta="Data"
                       v-model="parametri.dta"
                       messaggio_non_valido="Data non valida" />
        </cv-column>
        <cv-column :sm="4" :md="8" :lg="13">
          <cv-combo-box label="Seleziona una ditta" title="Ditta"
                        :auto-filter="true"
                        @change="cambiamento"
                        v-model="modello"
                        :options="options"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-text-input label="Descrizione" title="Descrizione" value="" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="6">
          <cv-text-input label="Importo" title="Importo" value="€ 200,00" />
        </cv-column>
        <cv-column :sm="4" :md="8" :lg="4">
          <cv-text-input label="Numero Fattura" title="Numero Fattura" value="14" />
        </cv-column>
        <cv-column :sm="4" :md="8" :lg="6">
          <data-valida etichetta="Data Fattura"
                       v-model="parametri.dta_fattura"
                       messaggio_non_valido="Data non valida" />
      </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Tipo di Pagamento</h6>
            <cv-radio-group :vertical="false"
                            title="Tipo di Pagamento" >
              <cv-radio-button name="tipo"
                               label="Contanti"
                               value="1"
                               v-model="modello_tipo_pagamento" />
              <cv-radio-button name="tipo"
                               label="Assegni"
                               value="2"
                               v-model="modello_tipo_pagamento" />
              <cv-radio-button name="tipo"
                               label="Varie"
                               value="3"
                               v-model="modello_tipo_pagamento" />
            </cv-radio-group>
          </cv-tile>
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Movimento</h6>
            <cv-radio-group :vertical="false">
              <cv-radio-button name="movimento"
                               label="Incasso"
                               value="1"
                               v-model="modello_movimento" />
              <cv-radio-button name="movimento"
                               label="Uscita"
                               value="2"
                               v-model="modello_movimento" />
            </cv-radio-group>
          </cv-tile>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-text-area label="Note" value=""></cv-text-area>
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <Bottoniera testo_nuovo="Nuova voce di bilancio"
                testo_salva="Salva Bilancio"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')"
    />
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";

export default {
  name: "Bilancio",
  components: { Bottoniera },
  data: function() {
    return {
      parametri: {
        dta: "16/02/2021",
        dta_fattura: "16/02/2021"
      },
      modello_tipo_pagamento: "1",
      modello_movimento: "1",
      modello: "Gianni Rossi s.r.l",
      options: [
        {
          value: "1",
          label: "Gianni Rossi s.r.l",
          name: "1",
        },
        {
          value: "2",
          label: "Mario Verdi s.r.l",
          name: "2",
        },
        {
          value: "3",
          label: "Paolo Bianchi s.r.l",
          name: "3",
        }
      ],
    }
  },
  methods: {
    cambiamento: function (evento) {
      console.log(evento);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/carbon';

</style>